import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close-circle.svg'
import _imports_1 from '../assets/list-view.svg'
import _imports_2 from '../assets/edit.svg'
import _imports_3 from '../assets/search.svg'
import _imports_4 from '../../globalModule/assets/paper-plane.svg'
import _imports_5 from '../assets/plus-circle.svg'
import _imports_6 from '../assets/package.svg'


const _withScopeId = n => (_pushScopeId("data-v-1e3736b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading-div" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"heading\" data-v-1e3736b2>Package Canvas</div><button class=\"icon-button\" data-v-1e3736b2><img src=\"" + _imports_3 + "\" data-v-1e3736b2></button><a class=\"icon-button\" target=\"_blank\" title=\"Report Bug or Issue\" href=\"https://docs.google.com/forms/d/e/1FAIpQLSfOkqKunFuJRsI8CqNlRKKNSrbBK56zWB2gMz0H9IVgP0hy0w/viewform\" data-v-1e3736b2><img src=\"" + _imports_4 + "\" data-v-1e3736b2></a>", 3)
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "packages-block-div"
}
const _hoisted_14 = { class: "new-package-div" }
const _hoisted_15 = {
  key: 1,
  class: "packages-list-div"
}
const _hoisted_16 = { class: "package-list-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "icon-button" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_6 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewEmptyPackage = _resolveComponent("NewEmptyPackage")!
  const _component_ControlPackage = _resolveComponent("ControlPackage")!
  const _component_ListPackage = _resolveComponent("ListPackage")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ActiveMessagesPopup = _resolveComponent("ActiveMessagesPopup")!
  const _component_MountedExecute = _resolveComponent("MountedExecute")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/controlCenter/${_ctx.workspaceId}`)))
      }, _hoisted_3),
      _createElementVNode("button", {
        class: _normalizeClass(["icon-button", {
        greyscale: _ctx.listView
      }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleListView()))
      }, _hoisted_5, 2),
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editingPackages = !_ctx.editingPackages))
      }, _hoisted_7),
      _hoisted_8,
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.generateWorkspaceZip()))
      }, _hoisted_12)
    ]),
    (!_ctx.listView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "icon-button new-package-btn",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.newPackageCount += 1))
            }, " + "),
            _createTextVNode(" Create new package ")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newPackageCount, (index) => {
            return (_openBlock(), _createBlock(_component_NewEmptyPackage, {
              key: index,
              newPackage: true,
              onInputSave: _ctx.createNewPackage,
              editing: _ctx.editingPackages,
              onDelete: () => (_ctx.newPackageCount -= 1)
            }, null, 8, ["onInputSave", "editing", "onDelete"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (currPackage) => {
            return (_openBlock(), _createBlock(_component_ControlPackage, {
              key: currPackage.id,
              packageName: currPackage.name,
              topics: currPackage.topics,
              services: currPackage.services,
              nodes: currPackage.nodes,
              robotPackage: currPackage.robotPackage,
              workspaceId: _ctx.workspaceId,
              packageId: currPackage.id,
              editing: _ctx.editingPackages,
              onInputSave: (newName) => _ctx.editPackageName(newName, currPackage),
              onDelete: () => _ctx.deletePackage(currPackage.name, currPackage.id),
              openWindow: _ctx.setPackageMessages
            }, null, 8, ["packageName", "topics", "services", "nodes", "robotPackage", "workspaceId", "packageId", "editing", "onInputSave", "onDelete", "openWindow"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.listView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("input", {
              class: "package-list-input",
              placeholder: "New Package",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listNewPackageName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.listNewPackageName]
            ]),
            _createElementVNode("button", {
              class: "rectangle-button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createNewPackage(_ctx.listNewPackageName)))
            }, " Create ")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (currPackage) => {
            return (_openBlock(), _createBlock(_component_ListPackage, {
              key: currPackage.id,
              pkg: currPackage,
              workspaceId: _ctx.workspaceId
            }, null, 8, ["pkg", "workspaceId"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog),
    _createVNode(_component_ActiveMessagesPopup, {
      visible: _ctx.displayPackages.length !== 0,
      setVisible: _ctx.setPopupVisibility,
      initFilter: _ctx.currMessageFilter,
      packages: _ctx.displayPackages
    }, null, 8, ["visible", "setVisible", "initFilter", "packages"]),
    _createVNode(_component_MountedExecute, {
      onNowMounted: _cache[7] || (_cache[7] = () => _ctx.reMount())
    })
  ], 64))
}